import ky, { type KyInstance } from 'ky';
import { env } from '@/shared/lib/env';
import { navigate } from 'wouter/use-browser-location';
import { logoutUser } from '@/shared/lib/logout';
import { isAtendimentoPath } from './atendimento-path';

const TOKEN_NAME = 'x-auth-token';

export function getToken(): string {
  try {
    // Tenta primeiro com o método mais robusto
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === TOKEN_NAME && value) {
        return decodeURIComponent(value);
      }
    }

    // Fallback para regex (menos confiável no Safari)
    const match = document.cookie.match(new RegExp(`(^| )${TOKEN_NAME}=([^;]+)`));
    return match ? decodeURIComponent(match[2]) : '';
  } catch (error) {
    console.warn('Erro ao ler cookie de autenticação:', error);
    return '';
  }
}

function getRedirectTo(): string {
  const redirectTo = window.location.pathname + window.location.search;
  
  // Salva a URL de redirecionamento no sessionStorage para persistir durante o login
  try {
    sessionStorage.setItem('auth-redirect-url', redirectTo);
    console.log('REDIRECT URL SAVED:', redirectTo);
  } catch (error) {
    console.error('Error saving redirect URL:', error);
  }

  return redirectTo;
}

// Sessão do cliente inválida (401): faz logout e manda para o login, voltando
// depois para a tela atual. Reaproveitado pelo cliente HTTP do atendimento (PRAT-64).
export function redirectToLogin(): void {
  // Fazer logout automático quando detectar erro 401
  logoutUser();

  const redirectTo = getRedirectTo();
  navigate(`/auth/access?redirectTo=${redirectTo}`);
}

export type Client = KyInstance;

export const client: KyInstance = ky.create({
  prefixUrl: env.VITE_API_URL,
  hooks: {
    beforeRequest: [
      request => {
        const token = getToken();
        if (token) request.headers.set('Authorization', `Bearer ${token}`);
        // A API usa o host para restringir pedidos à loja do domínio exclusivo
        if (typeof window !== 'undefined') request.headers.set('X-Store-Domain', window.location.host);
      },
    ],
    afterResponse: [
      (_, __, response) => {
        if (!response.ok && response.status === 401) {
          // PRATDEV-238: no atendimento (Nova Venda do operador / QR) um token de
          // cliente velho no navegador só é descartado. Mandar para o login
          // tirava o operador da Nova Venda antes mesmo de ele entrar.
          if (isAtendimentoPath(window.location.pathname)) {
            logoutUser();
            return response;
          }
          redirectToLogin();
          return response;
        }
        return response;
      },
    ],
  },
});
